<template>
  <div class="columns column is-1 is-offset-11">
    <sc-button text="Ajuda" theme="default" type="button" @click="callHelpScreen"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ScButton } from '@intelipost-js/secure-components';

const { mapState } = createNamespacedHelpers(
  'integrations/integrationsStep',
);

export default {
  name: 'help-button',
  computed: {
    ...mapState(['appDetails']),
  },
  methods: {
    callHelpScreen() {
      window.open(`${this.appDetails.app.public_doc}`, '_blank');
    },
  },
  components: {
    ScButton,
  },
};
</script>




// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/help-button/HelpButton.vue